module.exports = __webpack_public_path__ + "static/img/phone.aa1622ee.png";